import axios from "axios";

// Plural Actions
export const GET_PRODUCTION_STRUMIS_PRODUCTION_WORK_ORDER_PROCESSES = "GET_PRODUCTION_STRUMIS_PRODUCTION_WORK_ORDER_PROCESSES";
export const getProductionStrumisWorkOrderProductionProcesses = (filters) => {
  const url = `	/production/strumis/production/work_order_processes/search.json`;
  const request = axios.get(url, { params: filters });
  return {
    type: GET_PRODUCTION_STRUMIS_PRODUCTION_WORK_ORDER_PROCESSES,
    payload: request,
  };
};
